import { ThemeService } from './../../shared/theme-service/theme.service';
import { AutenticationEventType } from './../autentication.event.type';
import { Component, OnInit, ViewEncapsulation, OnDestroy, Input } from '@angular/core';
import { TweenMax, Quint, Sine, Back } from 'gsap';
import { AppEventDispatcher } from '../../utils/AppEventDispatcher';
import { Cookie } from 'ng2-cookies/ng2-cookies';
import { Auth } from '../Auth';
import { User } from '../models/user';
import { Access } from '../models/access';
import { EventTypes } from '../../shared/EventTypes';
import { AutenticationService } from '../autentication.service';

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class LoginComponent implements OnInit, OnDestroy {
	isOpenBank: boolean;
	logo: any;

	@Input() loading = false;
	hasCookie = false;

	constructor(
		private authService: AutenticationService,
		public themeService: ThemeService
	) {

	}

	ngOnInit() {
		AppEventDispatcher.listen(AutenticationEventType.LOGIN.RESET_LOGIN, () => {
			TweenMax.to('[data-component="login"]', .8, { width: 380, ease: Sine.easeOut});
			TweenMax.to('[data-component="login"] .logo', .8, { scale: 1, top: 40, ease: Sine.easeOut});
			TweenMax.delayedCall(.5, () => { AppEventDispatcher.dispatch(AutenticationEventType.LOGIN.MY_CPF, { show: true }); });
		});

		AppEventDispatcher.listen(AutenticationEventType.LOGIN.LOADER, show => {
			if (show.show) {
				this.showLoader();
			} else {
				this.hideLoader();
				this.checkCookie();
			}
		});

		AppEventDispatcher.listen(AutenticationEventType.LOGIN.BLOCK_LOADER, data => {
			this.loading = data.show;
		});

		if (this.themeService.themeConfigs) {
			this.logo = this.themeService.Logo ? this.themeService.Logo : '';
		}
	}

	checkCookie() {
		if (JSON.parse(Cookie.get('OmniAccountsList'))) {

			const cookieAccounts = JSON.parse(Cookie.get('OmniAccountsList'));
			const user: User = cookieAccounts['0'].user;
			Auth.cpf = user.cpf;
			this.hasCookie = true;

			this.authService.getUserByCpf(user.cpf).subscribe((access: Access) => {

				Auth.acceptTerms = access.acceptTerms;
				Auth.termsText = access.termsText;
				Auth.hasSecurityQuestions = access.hasSecurityQuestions;

				this.loading = false;

				if (access.exists) {
					if ( !Auth.acceptTerms ) {
						AppEventDispatcher.dispatch(EventTypes.TERMS.TERMS, { show: true, text: Auth.termsText, acceptHandler: this, access: access });
					}
				} else {
					AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: 'CPF não encontrado' });
				}

			}, error => {
				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
			});

		} else {
			this.loading = false;
			AppEventDispatcher.dispatch(AutenticationEventType.LOGIN.MY_CPF, {delay: 0});
		}
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(AutenticationEventType.LOGIN.RESET_LOGIN);
		AppEventDispatcher.removeListener(AutenticationEventType.LOGIN.MY_CPF);
		AppEventDispatcher.removeListener(AutenticationEventType.LOGIN.BLOCK_LOADER);
	}

	showLoader() {
		TweenMax.to('[data-component="login"] .login-loader', .8, { autoAlpha: 1, ease: Quint.easeOut });
		TweenMax.to('[data-component="login"] .login-loader .mat-spinner', .8, { delay: .2, scale: 1, ease: Back.easeOut });
	}

	hideLoader() {
		TweenMax.to('[data-component="login"] .login-loader', .8, { delay: .2, autoAlpha: 0, ease: Quint.easeOut });
		TweenMax.to('[data-component="login"] .login-loader .mat-spinner', .8, { scale: 0, ease: Back.easeOut });
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/autentication/login/login.component.ts